<template>
  <div>
    <!-- 标题 -->
    <div class="instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.region }}</BreadcrumbItem>
        <BreadcrumbItem to="/network/natMonitor">{{
          $t("alarms.network.nat.nat")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instance-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : azureList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
export default {
  name: "instanceNat",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // AWS折线图
      awsList: [],
      // 阿里云折线图
      alyList: [
        {
          id: "sessionActiveLimitDropConnectionCount",
          title: this.$t(
            "alarms.network.nat.line.SessionActiveLimitDropConnectionCount"
          ),
        },
        {
          id: "sessionNewLimitDropConnectionCount",
          title: this.$t(
            "alarms.network.nat.line.SessionNewLimitDropConnectionCount"
          ),
        },
        {
          id: "sessionActiveNewConnectionWaterLever",
          title: this.$t(
            "alarms.network.nat.line.SessionActiveNewConnectionWaterLever"
          ),
        },
        {
          id: "bWRateInFromOutToInsideBps",
          title: this.$t("alarms.network.nat.line.BWRateInFromOutToInsideBps"),
        },
        {
          id: "bytesInFromOutOutToInsideByte",
          title: this.$t(
            "alarms.network.nat.line.BytesInFromOutOutToInsideByte"
          ),
        },
        {
          id: "pPSRateInFromOutOutToInsideCount",
          title: this.$t(
            "alarms.network.nat.line.PPSRateInFromOutOutToInsideCount"
          ),
        },
        {
          id: "packetsInFromOutOutToInsideCount",
          title: this.$t(
            "alarms.network.nat.line.PacketsInFromOutOutToInsideCount"
          ),
        },
        {
          id: "bWRateInFromInOutToOutsideBps",
          title: this.$t(
            "alarms.network.nat.line.BWRateInFromInOutToOutsideBps"
          ),
        },
        {
          id: "bytesInFromInOutToOutsideByte",
          title: this.$t(
            "alarms.network.nat.line.BytesInFromInOutToOutsideByte"
          ),
        },
        {
          id: "pPSRateInFromInOutToOutsideCountS",
          title: this.$t(
            "alarms.network.nat.line.PPSRateInFromInOutToOutsideCountS"
          ),
        },
        {
          id: "packetsInFromInOutToOutsideCount",
          title: this.$t(
            "alarms.network.nat.line.PacketsInFromInOutToOutsideCount"
          ),
        },
      ],
      // azure折线图
      azureList: [],
      isAWS: false,
      isALY: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      monitorModule: "",
      natGatewayId: "",
      instanceId: "",
      // echarts实例
      sessionActiveLimitDropConnectionCountOptions: {},
      sessionNewLimitDropConnectionCountOptions: {},
      sessionActiveNewConnectionWaterLeverOptions: {},
      bWRateInFromOutToInsideBpsOptions: {},
      bytesInFromOutOutToInsideByteOptions: {},
      pPSRateInFromOutOutToInsideCountOptions: {},
      packetsInFromOutOutToInsideCountOptions: {},
      bWRateInFromInOutToOutsideBpsOptions: {},
      bytesInFromInOutToOutsideByteOptions: {},
      pPSRateInFromInOutToOutsideCountSOptions: {},
      packetsInFromInOutToOutsideCountOptions: {},
      chartSessionActiveLimitDropConnectionCount: "",
      chartSessionNewLimitDropConnectionCount: "",
      chartSessionActiveNewConnectionWaterLever: "",
      chartBWRateInFromOutToInsideBps: "",
      chartBytesInFromOutOutToInsideByte: "",
      chartPPSRateInFromOutOutToInsideCount: "",
      chartPacketsInFromOutOutToInsideCount: "",
      chartBWRateInFromInOutToOutsideBps: "",
      chartBytesInFromInOutToOutsideByte: "",
      chartPPSRateInFromInOutToOutsideCountS: "",
      chartPacketsInFromInOutToOutsideCount: "",
      //Aliyun数组
      sessionActiveLimitDropConnectionCount: [],
      sessionNewLimitDropConnectionCount: [],
      sessionActiveConnection: [],
      sessionLimitDropConnection: [],
      sessionNewConnection: [],
      sessionNewLimitDropConnection: [],
      sessionActiveConnectionWaterLever: [],
      sessionNewConnectionWaterLever: [],
      bwrateInFromOutside: [],
      bwrateOutToInside: [],
      bytesInFromInside: [],
      bytesOutToInside: [],
      ppsrateInFromInside: [],
      ppsrateInFromOutside: [],
      packetsInFromInside: [],
      packetsInFromOutside: [],
      bwrateInFromInside: [],
      bwrateOutToOutside: [],
      bytesInFromInside: [],
      bytesInFromOutside: [],
      ppsrateInFromInside: [],
      ppsrateInFromOutside: [],
      packetsInFromInside: [],
      packetsInFromOutside: [],
      xaxisData: [],
    };
  },
  mounted: function () {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {});
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartSessionActiveLimitDropConnectionCount.resize();
        self.chartSessionNewLimitDropConnectionCount.resize();
        self.chartSessionActiveNewConnectionWaterLever.resize();
        self.chartBWRateInFromOutToInsideBps.resize();
        self.chartBytesInFromOutOutToInsideByte.resize();
        self.chartPPSRateInFromOutOutToInsideCount.resize();
        self.chartPacketsInFromOutOutToInsideCount.resize();
        self.chartBWRateInFromInOutToOutsideBps.resize();
        self.chartBytesInFromInOutToOutsideByte.resize();
        self.chartPPSRateInFromInOutToOutsideCountS.resize();
        self.chartPacketsInFromInOutToOutsideCount.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.checkALINatGatewayIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "sessionActiveLimitDropConnectionCount") {
            var optionFll = this.sessionActiveLimitDropConnectionCountOption;
          } else if (item.id == "sessionNewLimitDropConnectionCount") {
            var optionFll = this.sessionNewLimitDropConnectionCountOption;
          } else if (item.id == "sessionActiveNewConnectionWaterLever") {
            var optionFll = this.sessionActiveNewConnectionWaterLeverOption;
          } else if (item.id == "bWRateInFromOutToInsideBps") {
            var optionFll = this.bWRateInFromOutToInsideBpsOption;
          } else if (item.id == "bytesInFromOutOutToInsideByte") {
            var optionFll = this.bytesInFromOutOutToInsideByteOption;
          } else if (item.id == "pPSRateInFromOutOutToInsideCount") {
            var optionFll = this.pPSRateInFromOutOutToInsideCountOption;
          } else if (item.id == "packetsInFromOutOutToInsideCount") {
            var optionFll = this.packetsInFromOutOutToInsideCountOption;
          } else if (item.id == "bWRateInFromInOutToOutsideBps") {
            var optionFll = this.bWRateInFromInOutToOutsideBpsOption;
          } else if (item.id == "bytesInFromInOutToOutsideByte") {
            var optionFll = this.bytesInFromInOutToOutsideByteOption;
          } else if (item.id == "pPSRateInFromInOutToOutsideCountS") {
            var optionFll = this.pPSRateInFromInOutToOutsideCountSOption;
          } else if (item.id == "packetsInFromInOutToOutsideCount") {
            var optionFll = this.packetsInFromInOutToOutsideCountOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // Aliyun折线图
    checkALINatGatewayIndex: function () {
      this.$api.nat
        .checkALINatGatewayIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          region: this.$route.query.region,
          monitorModule: 39,
          instanceId: this.$route.query.natGatewayId,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.sessionActiveLimitDropConnectionCount =
            res.data.sessionActiveLimitDropConnectionCount;
          this.sessionNewLimitDropConnectionCount =
            res.data.sessionNewLimitDropConnectionCount;
          this.sessionActiveConnection = res.data.sessionActiveConnection;
          this.sessionNewConnection = res.data.sessionNewConnection;
          this.sessionNewLimitDropConnection =
            res.data.sessionNewLimitDropConnection;
          this.sessionLimitDropConnection = res.data.sessionLimitDropConnection;
          this.sessionActiveNewConnectionWaterLever =
            res.data.sessionActiveNewConnectionWaterLever;
          this.sessionActiveConnectionWaterLever =
            res.data.sessionActiveConnectionWaterLever;
          this.sessionNewConnectionWaterLever =
            res.data.sessionNewConnectionWaterLever;
          this.bWRateInFromOutToInsideBps = res.data.bWRateInFromOutToInsideBps;
          this.bwrateInFromOutside = res.data.bwrateInFromOutside;
          this.bwrateOutToInside = res.data.bwrateOutToInside;
          this.bytesOutToInside = res.data.bytesOutToInside;
          this.bytesInFromOutside = res.data.bytesInFromOutside;
          this.bytesInFromOutOutToInsideByte =
            res.data.bytesInFromOutOutToInsideByte;
          this.pPSRateInFromOutOutToInsideCount =
            res.data.pPSRateInFromOutOutToInsideCount;
          this.ppsrateInFromInside = res.data.ppsrateInFromInside;
          this.ppsrateInFromOutside = res.data.ppsrateInFromOutside;
          this.packetsInFromOutOutToInsideCount =
            res.data.packetsInFromOutOutToInsideCount;
          this.packetsInFromInside = res.data.packetsInFromInside;
          this.packetsInFromOutside = res.data.packetsInFromOutside;
          this.bWRateInFromInOutToOutsideBps =
            res.data.bWRateInFromInOutToOutsideBps;
          this.bwrateInFromInside = res.data.bwrateInFromInside;
          this.bwrateOutToOutside = res.data.bwrateOutToOutside;
          this.bytesInFromInOutToOutsideByte =
            res.data.bytesInFromInOutToOutsideByte;
          this.bytesInFromInside = res.data.bytesInFromInside;
          this.bytesInFromOutside = res.data.bytesInFromOutside;
          this.pPSRateInFromInOutToOutsideCountS =
            res.data.pPSRateInFromInOutToOutsideCountS;
          this.ppsrateInFromInside = res.data.ppsrateInFromInside;
          this.ppsrateInFromOutside = res.data.ppsrateInFromOutside;
          this.packetsInFromInOutToOutsideCount =
            res.data.packetsInFromInOutToOutsideCount;
          this.packetsInFromInside = res.data.packetsInFromInside;
          this.packetsInFromOutside = res.data.packetsInFromOutside;
          this.packetsOutToInside = res.data.packetsOutToInside;
          this.ppsrateOutToOutside = res.data.ppsrateOutToOutside;
          this.bytesOutToOutside = res.data.bytesOutToOutside;
          this.packetsOutToOutside = res.data.packetsOutToOutside;
          this.allAws();
        });
    },
    changeTimeType: function () {
      this.checkAWSEipStatistics();
    },
    changeTimeTypeALY: function () {
      this.checkALINatGatewayIndex();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.sessionActiveLimitDropConnectionCountLine();
      this.sessionNewLimitDropConnectionCountLine();
      this.sessionActiveNewConnectionWaterLeverLine();
      this.bWRateInFromOutToInsideBpsLine();
      this.bytesInFromOutOutToInsideByteLine();
      this.pPSRateInFromOutOutToInsideCountLine();
      this.packetsInFromOutOutToInsideCountLine();
      this.bWRateInFromInOutToOutsideBpsLine();
      this.bytesInFromInOutToOutsideByteLine();
      this.pPSRateInFromInOutToOutsideCountSLine();
      this.packetsInFromInOutToOutsideCountLine();
    },
    /*************Aliyun折线图*****************************/
    //并发连接数/并发丢弃连接速率
    sessionActiveLimitDropConnectionCountLine: function () {
      this.chartSessionActiveLimitDropConnectionCount = this.$echarts.init(
        document.getElementById("sessionActiveLimitDropConnectionCount")
      );
      this.sessionActiveLimitDropConnectionCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.SessionActiveConnectionCount"),
            this.$t("alarms.network.nat.line.SessionLimitDropConnectionCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.nat.line.SessionActiveConnectionCount"
            ),
            type: "line",
            data: this.sessionActiveConnection,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.nat.line.SessionLimitDropConnectionCount"
            ),
            type: "line",
            data: this.sessionLimitDropConnection,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartSessionActiveLimitDropConnectionCount.setOption(
        this.sessionActiveLimitDropConnectionCountOption
      );
    },

    //新建连接速率/新建丢弃连接速率
    sessionNewLimitDropConnectionCountLine: function () {
      this.chartSessionNewLimitDropConnectionCount = this.$echarts.init(
        document.getElementById("sessionNewLimitDropConnectionCount")
      );
      this.sessionNewLimitDropConnectionCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.SessionNewConnectionCountS"),
            this.$t(
              "alarms.network.nat.line.SessionNewLimitDropConnectionCountS"
            ),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.SessionNewConnectionCountS"),
            type: "line",
            data: this.sessionNewConnection,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.nat.line.SessionNewLimitDropConnectionCountS"
            ),
            type: "line",
            data: this.sessionNewLimitDropConnection,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartSessionNewLimitDropConnectionCount.setOption(
        this.sessionNewLimitDropConnectionCountOption
      );
    },
    //并发连接水位/新建连接水位%
    sessionActiveNewConnectionWaterLeverLine: function () {
      this.chartSessionActiveNewConnectionWaterLever = this.$echarts.init(
        document.getElementById("sessionActiveNewConnectionWaterLever")
      );
      this.sessionActiveNewConnectionWaterLeverOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.nat.line.SessionActiveConnectionWaterLever"
            ),
            this.$t("alarms.network.nat.line.SessionNewConnectionWaterLever"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.nat.line.SessionActiveConnectionWaterLever"
            ),
            type: "line",
            data: this.sessionActiveConnectionWaterLever,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.nat.line.SessionNewConnectionWaterLever"
            ),
            type: "line",
            data: this.sessionNewConnectionWaterLever,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartSessionActiveNewConnectionWaterLever.setOption(
        this.sessionActiveNewConnectionWaterLeverOption
      );
    },

    //入方向流量速率（包含从公网来流量速率和入VPC流量速率）
    bWRateInFromOutToInsideBpsLine: function () {
      this.chartBWRateInFromOutToInsideBps = this.$echarts.init(
        document.getElementById("bWRateInFromOutToInsideBps")
      );
      this.bWRateInFromOutToInsideBpsOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.BWRateInFromOutsideBps"),
            this.$t("alarms.network.nat.line.BWRateOutToInsideBps"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.BWRateInFromOutsideBps"),
            type: "line",
            data: this.bwrateInFromOutside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.BWRateOutToInsideBps"),
            type: "line",
            data: this.bwrateOutToInside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartBWRateInFromOutToInsideBps.setOption(
        this.bWRateInFromOutToInsideBpsOption
      );
    },

    //入方向流量（包含从公网来流量和入VPC流量）
    bytesInFromOutOutToInsideByteLine: function () {
      this.chartBytesInFromOutOutToInsideByte = this.$echarts.init(
        document.getElementById("bytesInFromOutOutToInsideByte")
      );
      this.bytesInFromOutOutToInsideByteOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.BytesInFromOutsideByte"),
            this.$t("alarms.network.nat.line.BytesOutToInsideByte"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.BytesInFromOutsideByte"),
            type: "line",
            data: this.bytesInFromOutside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.BytesOutToInsideByte"),
            type: "line",
            data: this.bytesOutToInside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartBytesInFromOutOutToInsideByte.setOption(
        this.bytesInFromOutOutToInsideByteOption
      );
    },

    //入方向包速率（从公网来包速率和入VPC包速率）
    pPSRateInFromOutOutToInsideCountLine: function () {
      this.chartPPSRateInFromOutOutToInsideCount = this.$echarts.init(
        document.getElementById("pPSRateInFromOutOutToInsideCount")
      );
      this.pPSRateInFromOutOutToInsideCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.PPSRateInFromOutsideCount"),
            this.$t("alarms.network.nat.line.PPSRateOutToInsideCount"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.PPSRateInFromOutsideCount"),
            type: "line",
            data: this.ppsrateInFromOutside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.PPSRateOutToInsideCount"),
            type: "line",
            data: this.ppsrateInFromInside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPPSRateInFromOutOutToInsideCount.setOption(
        this.pPSRateInFromOutOutToInsideCountOption
      );
    },

    //入方向包量（包含从公网来包量和入VPC包量
    packetsInFromOutOutToInsideCountLine: function () {
      this.chartPacketsInFromOutOutToInsideCount = this.$echarts.init(
        document.getElementById("packetsInFromOutOutToInsideCount")
      );
      this.packetsInFromOutOutToInsideCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.PacketsOutToInsideCount"),
            this.$t("alarms.network.nat.line.PacketsInFromOutsideCount"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.PacketsOutToInsideCount"),
            type: "line",
            data: this.packetsOutToInside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.PacketsInFromOutsideCount"),
            type: "line",
            data: this.packetsInFromOutside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPacketsInFromOutOutToInsideCount.setOption(
        this.packetsInFromOutOutToInsideCountOption
      );
    },

    //出方向流量速率（包含从VPC来流量速率和入公网流量速率）
    bWRateInFromInOutToOutsideBpsLine: function () {
      this.chartBWRateInFromInOutToOutsideBps = this.$echarts.init(
        document.getElementById("bWRateInFromInOutToOutsideBps")
      );
      this.bWRateInFromInOutToOutsideBpsOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.BWRateInFromInsideBps"),
            this.$t("alarms.network.nat.line.BWRateOutToOutsideBps"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.BWRateInFromInsideBps"),
            type: "line",
            data: this.bwrateInFromInside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.BWRateOutToOutsideBps"),
            type: "line",
            data: this.bwrateOutToOutside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartBWRateInFromInOutToOutsideBps.setOption(
        this.bWRateInFromInOutToOutsideBpsOption
      );
    },

    //出方向流量（包含从VPC来流量和入公网流量）
    bytesInFromInOutToOutsideByteLine: function () {
      this.chartBytesInFromInOutToOutsideByte = this.$echarts.init(
        document.getElementById("bytesInFromInOutToOutsideByte")
      );
      this.bytesInFromInOutToOutsideByteOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.BytesInFromInsideByte"),
            this.$t("alarms.network.nat.line.BytesOutToOutsideByte"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.BytesInFromInsideByte"),
            type: "line",
            data: this.bytesInFromInside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.BytesOutToOutsideByte"),
            type: "line",
            data: this.bytesOutToOutside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartBytesInFromInOutToOutsideByte.setOption(
        this.bytesInFromInOutToOutsideByteOption
      );
    },

    //出方向包速率（包含从VPC来包速率和入公网包速率）
    pPSRateInFromInOutToOutsideCountSLine: function () {
      this.chartPPSRateInFromInOutToOutsideCountS = this.$echarts.init(
        document.getElementById("pPSRateInFromInOutToOutsideCountS")
      );
      this.pPSRateInFromInOutToOutsideCountSOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.PPSRateInFromInsideCountS"),
            this.$t("alarms.network.nat.line.PPSRateOutToOutsideCountS"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.PPSRateInFromInsideCountS"),
            type: "line",
            data: this.ppsrateInFromInside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.PPSRateOutToOutsideCountS"),
            type: "line",
            data: this.ppsrateOutToOutside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPPSRateInFromInOutToOutsideCountS.setOption(
        this.pPSRateInFromInOutToOutsideCountSOption
      );
    },

    //出方向包量（包含从VPC来包量和入公网包量）
    packetsInFromInOutToOutsideCountLine: function () {
      this.chartPacketsInFromInOutToOutsideCount = this.$echarts.init(
        document.getElementById("packetsInFromInOutToOutsideCount")
      );
      this.packetsInFromInOutToOutsideCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.nat.line.PacketsInFromInsideCount"),
            this.$t("alarms.network.nat.line.PacketsOutToOutsideCount"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.nat.line.PacketsInFromInsideCount"),
            type: "line",
            data: this.packetsInFromInside,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.nat.line.PacketsOutToOutsideCount"),
            type: "line",
            data: this.packetsOutToOutside,
            itemStyle: {
              normal: {
                color: "#7f4554",
                lineStyle: {
                  color: "#7f4554",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPacketsInFromInOutToOutsideCount.setOption(
        this.packetsInFromInOutToOutsideCountOption
      );
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.instanceId = this.$route.query.instanceId;
      this.$router.push({
        path: "/monitor/natDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-8 {
  margin-bottom: 20px;
}
.instance-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/nat/instance_dashboard/InstanceNat.vue